<template>
  <div class="HomePage">
     
    <v-stepper v-model="current_step" vertical>

      <v-stepper-step :complete="current_step > 1" step="1">{{ $t('transfer') }}</v-stepper-step>

      <v-stepper-content step="1">

        <v-col v-if="people <=3" cols="12">
          <v-row justify="center">
            <v-col cols="3">
              <svg height='300px' width='300px' fill="#000000" xml:space="preserve" version="1.1"
                style="width:100%;height:auto;shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;"
                viewBox="0 0 719 531" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd">
                <g>
                  <path class="fil0"
                    d="M35 209c-17,-3 -31,-18 -31,-35 0,-20 16,-36 36,-36l40 0c27,-58 50,-110 95,-138l369 0c45,28 68,80 95,138l40 0c20,0 36,16 36,36 0,17 -14,32 -31,35 55,54 30,221 28,297 0,14 -11,25 -25,25l-117 0c-14,0 -25,-11 -25,-25l0 -35 -371 0 0 35c0,14 -11,25 -25,25l-117 0c-14,0 -25,-11 -25,-25 -1,-76 -27,-243 28,-297zm147 -193c-43,13 -86,126 -101,171l558 0c-15,-45 -59,-158 -102,-171l-355 0zm39 333l0 71 278 0 0 -71 -278 0zm386 17l-31 14c-28,13 -21,47 -7,42l58 -22c10,-4 16,-30 12,-39 -3,-9 -24,1 -32,5zm1 -117l-55 26c-51,24 -38,85 -13,75l104 -39c19,-7 29,-55 23,-70 -5,-16 -43,1 -59,8zm-495 117l31 14c28,13 21,47 7,42l-58 -22c-11,-4 -16,-30 -13,-39 3,-9 24,1 33,5zm-2 -117l56 26c50,24 37,85 12,75l-104 -39c-18,-7 -29,-55 -23,-70 6,-16 43,1 59,8z">
                  </path>
                </g>
              </svg>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="people >3" cols="12">
          <v-row justify="center">
            <v-col cols="3" md="2">
              <svg height='300px' width='300px' fill="#000000" version="1.1" x="0px" y="0px"
                viewBox="-69.5 -52.5 97.5 109"
                style="width:100%;height:auto;enable-background:new -69.5 -52.5 97.5 109;" xml:space="preserve">
                <g>
                  <path
                    d="M20.9-11h-3.6c-0.8,0-1.4,0.6-1.4,1.4V0.9c0,0.8,0.6,1.4,1.4,1.4h3.6c0.8,0,1.4-0.6,1.4-1.4V-9.6   C22.3-10.4,21.7-11,20.9-11z">
                  </path>
                  <path
                    d="M-60.3-10.9h-3.6c-0.8,0-1.4,0.6-1.4,1.4V1c0,0.8,0.6,1.4,1.4,1.4h3.6c0.8,0,1.4-0.6,1.4-1.4V-9.5   C-58.9-10.3-59.5-10.9-60.3-10.9z">
                  </path>
                  <path
                    d="M-56.5,32.1c-0.1-0.2-0.1-0.3-0.1-0.3v9.6c0,0.8,0.6,1.4,1.4,1.4h6.7c0.8,0,1.4-0.6,1.4-1.4v-5.1h-4.5   C-54.1,36.3-56.2,34.4-56.5,32.1z">
                  </path>
                  <path
                    d="M8.4,36.3H3.8v5.1c0,0.8,0.6,1.4,1.4,1.4h6.7c0.8,0,1.4-0.6,1.4-1.4v-9.6c0,0,0,0.1-0.1,0.3C12.9,34.4,10.8,36.3,8.4,36.3z   ">
                  </path>
                  <path
                    d="M6.8-44.3c0,0-14.9-0.9-28.5-0.9s-27,0.8-27,0.8c-2.7,0-5,3.1-5,5.8c0,0-3.8,28.5-3.8,31.2c0,2.7,1,38,1,38   c0,2.7,2.2,4.9,4.9,4.9h7.8l3.9-1.8h36l4.4,1.8h8c2.7,0,4.9-2.2,4.9-4.9c0,0,1.3-31.1,1.3-37.3c0-6.2-2.9-32.1-2.9-32.1   C11.7-41.4,10.6-43.9,6.8-44.3z M-52.6,12.5c-1.5-0.5-1.8-1.7-1.9-2.4c-0.5-1.7-0.3-5.5-0.3-5.5c0-0.9,0.7-2.5,3.3-1.5   c0,0,2.9,1.1,4.6,2.1c0.8,0.5,1.6,1.6,2.4,3.7c0.8,2.1,1.7,4.7,1.5,5.3c-0.1,0.4-0.9,0.3-2.4,0C-46.4,14-50.5,13.2-52.6,12.5z    M-45.4,31c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5S-44.1,31-45.4,31z M-7.2,26c-0.4,1.2-1.4,2.4-2.5,2.5   c-4.9,0.4-18.5,0.5-23.6,0.1c-1.1-0.1-2.4-0.6-3-2.6c-1.8-5.7-4.9-19.6-4.9-19.6h39.3C-1.9,6.4-5.5,20.6-7.2,26z M1.9,31   c-1.4,0-2.5-1.1-2.5-2.5S0.6,26,1.9,26s2.5,1.1,2.5,2.5S3.3,31,1.9,31z M11,10.7c-0.2,0.6-0.4,1.9-1.9,2.4   c-2.1,0.7-6.1,1.5-7.1,1.7c-1.6,0.3-2.3,0.4-2.4,0c-0.1-0.6,0.7-3.2,1.5-5.3c0.8-2.1,1.6-3.2,2.4-3.7C5.2,4.7,8,3.6,8,3.6   c2.6-1,3.3,0.7,3.3,1.5C11.3,5.2,11.5,9,11,10.7z M11.5-10.1c-0.1,0.8-0.4,2.2-0.7,3.1c-0.2,0.5-0.3,0.8-0.9,0.8   c-0.3,0-16.8-0.4-32-0.3c-15.2,0-30.4-0.1-30.7-0.1c-0.5,0-0.7-0.2-0.9-0.8c-0.3-0.8-0.6-2.2-0.7-3.1c-0.1-1.3,1.7-13.8,1.7-13.8   c0.3-2,1-2.8,2.5-2.8c0,0,8.6-0.6,28-0.6c19.4,0,29.6,0.9,29.6,0.9c1.5,0,2.2,0.7,2.5,2.8C10.1-24,11.6-11.4,11.5-10.1z">
                  </path>
                </g>
              </svg>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="py-0">

       
          <v-combobox v-model="from_model" :loading="isFromLoading" :items="from_items" :search-input.sync="search_from"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('startplace')"
            :placeholder="$t('startplace_text')" prepend-icon="place" clearable return-object>
          </v-combobox>
       
          <v-combobox v-model="to_model" :loading="isToLoading" :items="to_items" :search-input.sync="search_to"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('endplace')"
            :placeholder="$t('endplace_text')" prepend-icon="place" clearable return-object>
          </v-combobox>
       
          <v-text-field :label="$t('people')" :placeholder="$t('people_text')" v-model="people" prepend-icon="person"
            hide-details single-line type="number" min=1>
            <template v-slot:append>
              <v-btn tile color="primary" class="ma-0" @click="inc">+</v-btn>
              <v-btn tile color="primary" class="ma-0" @click="dec">-</v-btn>
            </template>
          </v-text-field>
       
          <v-row justify="center" class="py-0">
            <v-col cols="5" class="py-0">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="date_a" :label="$t('startdate')" :placeholder="$t('startdate_text')" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker :locale=bcp47($i18n.locale) :min="datemin" v-model="date_a" @input="menu1 = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5" class="py-0">
              <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time_a" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="time_a" :label="$t('starttime')" :placeholder="$t('starttime_text')" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker :locale=bcp47($i18n.locale) v-if="menu2" v-model="time_a" @click:minute="$refs.menu2.save(time_a)">
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-switch v-model="ar" :label="$t('a_r')"
              ></v-switch>
            </v-col>
          </v-row>
           <v-row justify="center" class="py-0" v-if=ar>
            <v-col cols="5" class="py-0">
              <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="date_r" :label="$t('returndate')" :placeholder="$t('returndate_text')" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker :locale=bcp47($i18n.locale) :min="datemin" v-model="date_r" @input="menu3 = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="7" class="py-0">
              <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time_r" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="time_r" :label="$t('returntime')" :placeholder="$t('returntime_text')" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker :locale=bcp47($i18n.locale) v-if="menu4" v-model="time_r" @click:minute="$refs.menu4.save(time_r)">
                </v-time-picker>
              </v-menu>
            </v-col>
            </v-row>
        </v-col>

        <v-card-text v-if="showPrice=='ok'">
          <v-alert class="pa-6" type="success">
            <p>{{ $t('transfer_for') }} {{ people }} {{ $tc('person',people) }}:</p>
            <p class="text-center display-1">{{totalprice}} €</p>
          </v-alert>
        </v-card-text>
        <v-card-text v-if="getStatus=='ask'">
          <v-alert class="pa-6" type="info">
            {{ $t('ask_message_1') }}<br />
            {{ $t('ask_message_2') }}
          </v-alert>
          <v-btn color="primary" @click="goToStep(2)" block large>{{ $t('continue') }}</v-btn>

        </v-card-text>

        <v-card-text v-if="getStatus=='ok'">
          <v-btn color="primary" @click="goToStep(2)" block large>{{ $t('continue') }}</v-btn>
        </v-card-text>
      
      </v-stepper-content>

      <!--
      Secondo step
      -->

      <v-stepper-step :complete="current_step > 2" step="2">{{ $t('extra_services') }}</v-stepper-step>
      <v-stepper-content step="2">

        <v-row>
          <v-card-text>
            <v-col cols="12">
              <v-switch v-for="extra in extras" v-model="selected_extras" v-bind:key="extra.name"
                :label="extra.name" :value="extra.name">
              </v-switch>
            </v-col>
          </v-card-text>
        </v-row>
        <v-card class="d-flex justify-space-between" flat tile>
          <v-btn color="primary" @click="goToStep(3)">{{ $t('continue') }}</v-btn>
          <v-btn depressed @click="goToStep(1)">
            <v-icon left>mdi-menu-up</v-icon> {{ $t('back') }}
          </v-btn>
        </v-card>
      </v-stepper-content>

      <!--

Terzo step

  -->

      <v-stepper-step :complete="current_step > 3" step="3">{{ $t('contact') }}</v-stepper-step>
      <v-stepper-content step="3">

        <v-row justify="center" class="">
          <v-col cols="6" class="">

            <v-text-field prepend-icon="person" :label="$t('first_name')" :placeholder="$t('first_name_text')"
              :hint="$t('first_name_text')" v-model="first_name">
            </v-text-field>

          </v-col>
          <v-col cols="6" class="">
            <v-text-field :label="$t('last_name')" :placeholder="$t('last_name_text')" :hint="$t('last_name_text')"
              v-model="last_name">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" class="">
          <v-col cols="12" class="">
            <v-text-field prepend-icon="phone" :label="$t('cellphone')" :placeholder="$t('cellphone_text')"
              :hint="$t('cellphone_hint')" v-model="phone">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" class="">
          <v-col cols="12" class="">
            <p class="pl-9">{{$t('pickup_info_text')}}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea rows="3" prepend-icon="comment" :label="$t('pickup_info')" :hint="$t('pickup_info')"
              v-model="notes"></v-textarea>
          </v-col>
        </v-row>


        <v-card class="d-flex justify-space-between" flat tile>
          <v-btn color="primary" @click="goToStep(4)">{{ $t('confirm') }}</v-btn>
          
          
          <v-btn depressed @click="goToStep(2)">
            <v-icon left>mdi-menu-up</v-icon> {{ $t('back') }}
          </v-btn>

        </v-card>
      </v-stepper-content>

      <!--

Quarto step

  -->





      <v-stepper-step step="4">{{ $t('payment_details') }}</v-stepper-step>
      <v-stepper-content step="4">

        <v-row>
            <v-col cols="12">
              
              <div class="credit-card">
                <img src="../assets/logo/stripe.svg" style="height:3rem;"/>
                <card class='stripe-card'
                  :class='{ complete }'
                  :stripe=stripeKey
                  :options=stripeOptions
                  @change='complete = $event.complete'
                />
                <div class="cards">
                <img src="../assets/logo/visa.svg"/>
                <img src="../assets/logo/mastercard.svg"/>
                <img src="../assets/logo/amex.svg"/>
                <img src="../assets/logo/jcb.svg"/>
                <img src="../assets/logo/discover.svg"/>
                <img src="../assets/logo/diners.svg"/>
                </div>
                </div>

            </v-col>
        </v-row>

           <v-card class="d-flex justify-space-between" flat tile>
          <v-btn color="primary" @click='pay'  :disabled='!complete'>{{ $t('pay_with_credit_card') }}</v-btn>
          
          
          <v-btn depressed @click="goToStep(2)">
            <v-icon left>mdi-menu-up</v-icon> {{ $t('back') }}
          </v-btn>

        </v-card>
      

        </v-stepper-content>
    </v-stepper>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='number'] {
    -moz-appearance:textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.cards {
  padding-top:1rem;
  display:flex;
  justify-content: flex-end;
}
.cards img {
  display:block;
height:1.5rem;
margin-left:.2rem;

}

.credit-card {
  background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
 box-shadow: 2px 2px 2px  rgba(0,0,0,0.4);

 border-radius:5px;
 padding: 1rem 1rem 2rem 1rem;
}

.stripe-card { 
  background: #fff;
  padding: 3px;
  border: 1px solid #ccc;
}

</style>


<script>
/* eslint-disable no-console */
//import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements-plus'

//import {mapState} from 'vuex';
//import {mapGetters} from 'vuex';
  export default {
    name: 'HomePage',
    components: { Card },
    data() {
      return {
        complete:false,
        stripeOptions: { hidePostalCode: true },
        stripeKey: 'pk_test_akPq9zZdyMXJpQ2kb0Me6nlr00axgVWH0d',
  //      current_step: 1,

        descriptionLimit: 60,
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        datemin: new Date().toISOString(),

 //       date: null,
  //      time: null,
//        status: "wait",
/*
        book: {
          first_name: "",
          last_name: "",
          phone: "",
          notes: "" 
        },
*/
    //    from_model: null,
//        from_items: [],
//        isFromLoading: false,
        search_from: null,


      //  to_model: null,
        //to_items: [],
        //isToLoading: false,
        search_to: null,

//        price: null,
//        totalprice: null,

 //       people: 1,

 //       extras: [],
 //       selected_extras: [],

        isBookSaving: false,



      isFromLoading: false,
      isToLoading: false

      }

    },
    computed: {
      date_a: {
        get() {
          return this.$store.state.transfer.date_a
        },
        set(val) {
        this.$store.commit('transfer_set_date_a',val)
        }
      },
      time_a: {
        get() {
          return this.$store.state.transfer.time_a
        },       
        set(val) {
         // this.$store.state.transfer.time=val
            this.$store.commit('transfer_set_time_a',val)
        }
      },
      date_r: {
        get() {
          return this.$store.state.transfer.date_r
        },
        set(val) {
        this.$store.commit('transfer_set_date_r',val)
        }
      },
      time_r: {
        get() {
          return this.$store.state.transfer.time_r
        },       
        set(val) {
         // this.$store.state.transfer.time=val
            this.$store.commit('transfer_set_time_r',val)
        }
      },
      ar: {
        get() {
          return this.$store.state.transfer.ar
        },
        set(val) {
          this.$store.dispatch('transferSetAR',val)
        }
      },
      
      from_model: {
        get() {
          return this.$store.state.transfer.from
        },
        set(val) {
            this.$store.commit('transfer_set_from',val)
        }
      },
      from_items: {
        get() {
          return this.$store.state.transfer.from_items
        },
        set(val) {
          this.$store.dispatch('transferSearchFrom',val)
        }
      },
      to_model: {
        get() {
          return this.$store.state.transfer.to
        },
        set(val) {
            this.$store.commit('transfer_set_to',val)
        }
      },
      to_items: {
        get() {
          return this.$store.state.transfer.to_items
        },
        set(val) {
          this.$store.dispatch('transferSearchTo',val)
        }
      },
      people: {
        get() {
          return this.$store.state.transfer.people
        },
        set(val) {
          this.$store.dispatch('transferSetPeople',val)
        }
      },
      current_step: {
        get() {
          return this.$store.state.transfer.current_step
        },
        set(val) {
          this.$store.dispatch('go_to_step',val)
        }
      },
      selected_extras: {
        get() {
          return this.$store.state.transfer.selected_extras
        },
        set(val) {
          this.$store.dispatch('selectedExtras',val)
        }
      },
      /*
      * User Details
      */
      first_name: {
        get() {
          return this.$store.state.transfer.first_name;
        },
        set(val) {
          this.$store.dispatch('transferSetFirstName',val)
        }
      },
      last_name: {
        get() {
          return this.$store.state.transfer.last_name;
        },
        set(val) {
          this.$store.dispatch('transferSetLastName',val)
        }
      },
      phone: {
        get() {
          return this.$store.state.transfer.phone;
        },
        set(val) {
          this.$store.dispatch('transferSetPhone',val)
        }
      },
      notes: {
        get() {
          return this.$store.state.transfer.notes;
        },
        set(val) {
          this.$store.dispatch('transferSetNotes',val)
        }
      },


      totalprice() {
        if (this.$store.state.transfer.ar) {
          return this.$store.state.transfer.totalprice + this.$store.state.transfer.totalprice
        } else {
          return this.$store.state.transfer.totalprice
        }
      },
      extras() {
        return this.$store.state.transfer.extras
      },
      //...mapState(['from_items','to_items']),
    //  ...mapGetters(['people','date','time','from_model','to_model','current_step']),
      /*
isFromLoading() {
			return this.$store.state.isFromLoading;
		},
from_items() {
			return this.$store.state.from_items;
    },
    */
      showPrice() {
        if ((this.people > 0)  && (this.from_model != null) && (this.to_model != null)) {
          this.getPrice()
        } else {
          return "wait"
        }
        return 'ok'
      },

      getStatus() {
        if ((this.people > 0) && (this.date_a != null) && (this.time_a != null) && (this.from_model != null) && (this
            .to_model != null)) {
          this.getPrice()
        } else {
          return "wait"
        }
        return this.$store.state.transfer.status

      }
    },
    methods: {
     
      pay () {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then(data => console.log(data.token))
    },
      goToStep(val) {
       // this.$store.state.transfer.current_step = 2
        
        this.$store.dispatch('goToStep',val)

      },
      Book() {
        this.current_step=4
        this.isBookSaving = false
        // eslint-disable-next-line
        //console.log(this.selected_extras)
       
        fetch('https://marketplace.italyservices.it/martinimultimedia/transfer/book',{method:"post",body:this.book})
              .then(resp => {
                if(resp.status==200){
                   return resp.json()
                }else{
                    console.log("Status: "+resp.status);
                    return Promise.reject("server")
                }
              })
              .catch(err =>{
                if(err=="server")return
                console.log(err);
            })
            .finally(() => (this.isBookSaving = true))

      },
      bcp47(locale) {

        return locale + "-" + locale.toUpperCase()
      },
      dec() {
        this.$store.commit('transfer_people_remove')
      /*  if (this.people > 1) {
          this.people--
        }
        */
      },
      inc() {
         this.$store.commit('transfer_people_add',0)
        /*
        // eslint-disable-next-line
        console.log(this.$i18n.locale)
        this.people++
        */
      },
      getPrice() {
        if (!this.people) return
        this.$store.dispatch('getPrice',{ from: this.search_from, to: this.search_to, people: this.people})
      }
      /*
      getPrice() {
        if (!this.people) return

        fetch('https://marketplace.italyservices.it/martinimultimedia/transfer/price/' + this.search_from + '/' + this
            .search_to +
            '/' + this.people)
          .then(res => res.json())
          .then(res => {
            // eslint-disable-next-line
            console.log(res)
            this.totalprice = res[0].total
            this.status = res[0].status
          })
          .catch(err => {
            // eslint-disable-next-line
            console.log(err)
          })
          .finally(() => (this.isFromLoading = false))
      },
      */

    },

    watch: {
      async search_from(val) {
            this.isFromLoading = true
            try {
              await this.$store.dispatch('transferSearchFrom',val)
              this.isFromLoading = false
            } catch (error) {
              this.isFromLoading = false
            }
      },
      async search_to(val) {
            this.isToLoading = true
            try {
              await this.$store.dispatch('transferSearchTo',val)
              this.isToLoading = false
            } catch (error) {
              this.isToLoading = false
            }
      },
      /* 
      date(val) {
        this.$store.dispatch('transferOnDate',val)
      },
     time(val) {
        this.$store.dispatch('transferOnTime',val)
      },
      people(val) {
        this.$store.dispatch('transferSetPeople',val)
      }
      */
      
    },
    mounted(){
      this.$store.dispatch('getExtras',this.$i18n.locale)
    }
  }
</script>

